import {Route, Routes} from 'react-router-dom'
import {SignIn} from './components/SignIn'
import {SignOut} from './components/SignOut'
import { PublicLayout } from '../../layouts/PublicLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<PublicLayout/>}>
      <Route path='sign-in' element={<SignIn />} />
      <Route path='sign-in/apple/:idToken' element={<SignIn />} />
    </Route>
    <Route path='sign-out' element={<SignOut />} />
  </Routes>
)

export {AuthPage}
